import React from "react";

export const PageHeader = ({ title, sub, action }) => (
  <div className="flex items-start justify-between gap-3 flex-wrap border-b border-zinc-800 px-4 py-4 sm:px-8 sm:py-6 bg-zinc-950/60 backdrop-blur sticky top-14 lg:top-0 z-10">
    <div>
      <h1 className="text-xl sm:text-2xl tracking-tight font-medium text-zinc-50" style={{ fontFamily: "Outfit, sans-serif" }}>{title}</h1>
      {sub && <p className="text-xs sm:text-sm text-zinc-400 mt-1">{sub}</p>}
    </div>
    {action}
  </div>
);

export const Stat = ({ label, value, accent = "zinc", testid }) => (
  <div className="bg-zinc-950 border border-zinc-800 rounded-lg p-5" data-testid={testid}>
    <div className="text-xs font-mono uppercase tracking-[0.2em] text-zinc-500 mb-2">{label}</div>
    <div className={`text-2xl font-mono font-medium tracking-tight text-${accent}-100`}>{value}</div>
  </div>
);

export const Card = ({ children, className = "", ...rest }) => (
  <div className={`bg-zinc-950 border border-zinc-800 rounded-lg ${className}`} {...rest}>{children}</div>
);

export const Button = ({ children, variant = "primary", className = "", ...rest }) => {
  const variants = {
    primary: "bg-blue-600 hover:bg-blue-700 text-white",
    ghost: "hover:bg-zinc-900 text-zinc-300 hover:text-white border border-zinc-800",
    danger: "bg-red-500/10 text-red-400 border border-red-500/30 hover:bg-red-500/20",
    success: "bg-green-500/10 text-green-400 border border-green-500/30 hover:bg-green-500/20",
  };
  return (
    <button {...rest} className={`px-4 py-2 rounded-md font-medium text-sm transition-colors ${variants[variant]} ${className}`}>{children}</button>
  );
};

export const Input = ({ label, ...props }) => (
  <div>
    {label && <label className="text-sm font-medium text-zinc-400 mb-1.5 block">{label}</label>}
    <input
      {...props}
      className={`w-full bg-zinc-900 border border-zinc-800 rounded-md px-3 py-2 text-zinc-100 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all outline-none placeholder-zinc-600 text-sm ${props.className || ""}`}
    />
  </div>
);

export const Select = ({ label, options, ...props }) => (
  <div>
    {label && <label className="text-sm font-medium text-zinc-400 mb-1.5 block">{label}</label>}
    <select
      {...props}
      className="w-full bg-zinc-900 border border-zinc-800 rounded-md px-3 py-2 text-zinc-100 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all outline-none text-sm"
    >
      {options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
    </select>
  </div>
);

export const SignalBadge = ({ direction }) => {
  const map = {
    BUY: "bg-green-500/10 text-green-400 border-green-500/30",
    SELL: "bg-red-500/10 text-red-400 border-red-500/30",
    WAIT: "bg-yellow-500/10 text-yellow-400 border-yellow-500/30",
  };
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md font-mono font-medium text-xs border ${map[direction] || map.WAIT}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current" /> {direction}
    </span>
  );
};

export const Grade = ({ grade }) => {
  const map = {
    "A+": "bg-green-500/15 text-green-400 border-green-500/40",
    "A": "bg-green-500/10 text-green-400 border-green-500/30",
    "B": "bg-blue-500/10 text-blue-400 border-blue-500/30",
    "C": "bg-yellow-500/10 text-yellow-400 border-yellow-500/30",
    "D": "bg-orange-500/10 text-orange-400 border-orange-500/30",
    "F": "bg-red-500/10 text-red-400 border-red-500/30",
  };
  return <span className={`inline-flex items-center justify-center w-10 h-10 rounded-md font-mono font-bold text-lg border ${map[grade] || map.C}`}>{grade}</span>;
};
